
import styled from 'styled-components'

export const StyledInput = styled.input`
  width: 85%;
  height: 3em;
  padding: 6px 12px;
  border: 1px solid #efefef;
  outline-width: thin;
  border-color: ${props => (props.setErrorBorderColor ? '#e30613' : '#efefef')};
  outline: ${props => (props.setErrorBorderColor ? 'none' : 'initial')};  
  margin-bottom: ${props => (props.inputError ? "10px" : "30px")};

  ::placeholder {
    color: #555;
    font-size: 1em;
    font-weight: 300;
  }
`

export const StyledNewsletterForm = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 1000px) {
    flex-direction: row;
    justify-content: space-between;

    div {
      width: 30%;

      input {
        width: 100%
      }

      div {
        width: 100%
      }
    }
  }
`